module.exports = __webpack_public_path__ + "img/booking.d0d222e7.png";